import { NavLink } from 'react-router-dom';

import styled from '@emotion/styled';
import { css } from '@emotion/react';

export const IconContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 35px;
    height: 35px;
    ${(props) => css`
        background-color: ${props.isOpen ? props.theme.color.grayDark : props.theme.color.black};
        @media (max-width: ${props.theme.breakpoint.tablet}px) {
            width: 48px;
            height: 48px;
        }
        &:hover {
            background-color: ${props.isOpen ? props.theme.color.grayDark : props.theme.color.gray3};
        }
    `};
`;

export const Container = styled.div`
    cursor: pointer;
    position: relative;
    margin-right: ${(p) => p.theme.size.medium};
`;

const radiusCss = () => css`
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
`;

export const MenuPanel = styled.div`
    position: absolute;
    right: 0;
    margin-right: -1px;
    margin-top: -1px;
    ${radiusCss};
    background-color: ${({ theme: { color } }) => color.black};
    box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.5);
    min-width: 242px;
    z-index: 1000;
    user-select: none;
    border: 1px solid ${({ theme: { color } }) => color.black};
`;

export const MenuItem = styled.div`
    display: flex;
    flex: 1;
    align-items: center;
    justify-content: space-between;
    ${(props) => css`
        background-color: ${props.isOpen ? props.theme.color.gray3 : props.theme.color.grayDark};
        color: ${props.theme.color.white};
        padding: ${props.theme.size.medium};
        font-size: ${props.large ? props.theme.fontSize.mediumLarge : props.theme.fontSize.medium};
        &:hover {
            color: ${props.theme.color.white};
            ${!props.noLink && `background-color: ${props.theme.color.gray3}`};
        }
        ${props.isLeft && 'justify-content: flex-start'};
        font-weight: ${props.isBold ? 500 : 400};
        ${props.noLink && 'cursor: default'};
    `};
    padding-right: 12px;

    :not(:last-child) {
        border-bottom: 1px solid ${({ theme: { color } }) => color.black};
    }

    :last-child {
        ${radiusCss};
    }

    min-height: 48px;
`;

export const MenuLink = MenuItem.withComponent(NavLink);
export const MenuRetroLink = MenuItem.withComponent('a');
